import styled from 'styled-components';

export const SearchOption = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.link};

  & > button {
    margin-left: 10px;
  }
`;
